import { useState, useEffect } from 'react';
// @ts-expect-error - virtual module from vite-plugin-pwa
import { useRegisterSW } from 'virtual:pwa-register/react';
import { X, RefreshCw } from 'lucide-react';

export const UpdateNotification = () => {
    const [showUpdate, setShowUpdate] = useState(false);

    const {
        offlineReady: [offlineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(_r: unknown) {
            console.log('SW Registered');
        },
        onRegisterError(error: unknown) {
            console.log('SW registration error', error);
        },
    });

    useEffect(() => {
        if (needRefresh) {
            setShowUpdate(true);
        }
    }, [needRefresh]);

    const handleUpdate = () => {
        updateServiceWorker(true);
    };

    const handleClose = () => {
        setShowUpdate(false);
        setNeedRefresh(false);
    };

    if (!showUpdate) return null;

    return (
        <div className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl shadow-2xl p-4 flex items-start gap-3">
                <div className="flex-shrink-0 mt-0.5">
                    <RefreshCw className="w-5 h-5" />
                </div>

                <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-sm mb-1">
                        Phiên bản mới có sẵn! 🎉
                    </h3>
                    <p className="text-sm text-blue-100 mb-3">
                        Cập nhật ngay để trải nghiệm tính năng mới nhất
                    </p>

                    <div className="flex gap-2">
                        <button
                            onClick={handleUpdate}
                            className="px-4 py-2 bg-white text-blue-600 font-medium text-sm rounded-lg hover:bg-blue-50 active:scale-95 transition-all"
                        >
                            Cập nhật ngay
                        </button>
                        <button
                            onClick={handleClose}
                            className="px-4 py-2 bg-blue-800 text-white font-medium text-sm rounded-lg hover:bg-blue-900 active:scale-95 transition-all"
                        >
                            Để sau
                        </button>
                    </div>
                </div>

                <button
                    onClick={handleClose}
                    className="flex-shrink-0 p-1 hover:bg-blue-800 rounded transition-colors"
                    aria-label="Đóng"
                >
                    <X className="w-5 h-5" />
                </button>
            </div>

            {offlineReady && (
                <div className="mt-2 text-xs text-center text-blue-600 bg-blue-50 py-2 px-3 rounded-lg">
                    ✓ Ứng dụng đã sẵn sàng offline
                </div>
            )}
        </div>
    );
};
